import { CommandByteSequence, ExtractDataFunctionReturn, ParsedArgs } from '../types';
import { print2dCodes, printBarcode, printRasterBitImage, selectBitImageMode, specifyGraphicsData, specifyGraphicsDataAlternative } from './commands';
import * as Graphics from './graphics';

export const extractData = (command: CommandByteSequence, parsedArgs?: ParsedArgs): ExtractDataFunctionReturn | undefined => {
  switch (command) {
    // case `${ESC}\x44`:
    //   return horizontalTabPosRule;

    case selectBitImageMode:
      return Graphics.selectBitImageModeCommand(parsedArgs);

    // case `${ESC}\x2e`:
    //   return advancedRasterGraphicModeRule;

    // case `${GS}\x2a`:
    //   return defineDownloadedBitImageModeRule;

    // case `${FS}\x71`:
    //   return defineNVBitImageModeRule;

    case printRasterBitImage:
      return Graphics.printRasterBitImageModeCommand(parsedArgs);

    case specifyGraphicsData:
    case specifyGraphicsDataAlternative:
      return Graphics.specifyGraphicDataCommand(parsedArgs);

    case printBarcode:
      return Graphics.printBarcodeCommand(parsedArgs);

    case print2dCodes:
      return Graphics.print2dCodesCommand(parsedArgs);

    default:
      return undefined;
  }
};
